import { FC } from 'react';
// components
import FormulationSyrupType from 'components/main/FormulationSyrupType/Edit';

const Edit: FC = () => <FormulationSyrupType />;

export default Edit;
